(() => {
  const initUpsell = () => {
    const upsellComponents = document.querySelectorAll('.c-upsell');

    upsellComponents.forEach(upsell => {
      const toggleBtn = upsell.querySelector('[data-upsell-toggle]');
      const deleteBtn = upsell.querySelector('[data-upsell-delete]');
      const bookedText = upsell.querySelector('.js-upsell-booked-label');

      if (!toggleBtn || !deleteBtn || !bookedText) return;

      const handleToggle = () => {
        toggleBtn.classList.add('is-active');
        toggleBtn.setAttribute('aria-pressed', 'true');
        bookedText.style.display = 'inline-flex';
        deleteBtn.style.display = 'inline-flex';
        deleteBtn.focus();
      };

      const handleDelete = () => {
        toggleBtn.classList.remove('is-active');
        toggleBtn.setAttribute('aria-pressed', 'false');
        bookedText.style.display = 'none';
        deleteBtn.style.display = 'none';
        toggleBtn.focus();
      };

      toggleBtn.addEventListener('click', handleToggle);
      deleteBtn.addEventListener('click', handleDelete);

      // Gestione della tastiera
      toggleBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      });

      deleteBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleDelete();
        }
      });
    });
  };

  // Inizializza solo quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsell);
  } else {
    initUpsell();
  }
})(); 